// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3lWVwSCIjI1qaHTzn19Sg5{flex-grow:1;margin:0 1rem}._28CO0ebabp70_w1cSNKO0p{font-size:1.4rem;min-width:7.5rem}._3bPNEhSRvoB2nJrNg6SrZl{margin-right:.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": "_3lWVwSCIjI1qaHTzn19Sg5",
	"label": "_28CO0ebabp70_w1cSNKO0p",
	"intervals": "_3bPNEhSRvoB2nJrNg6SrZl"
};
module.exports = ___CSS_LOADER_EXPORT___;
